import type { CSSProperties, PropsWithChildren } from 'react';
import styled from 'styled-components';

const Root = styled.div`
  position: relative;
  isolation: isolate;
  background: var(--c-nd-50-opaque);
  backdrop-filter: blur(64px);
  padding-bottom: calc(var(--triangle-height) + var(--unit));
  clip-path: polygon(
    0 0,
    100% 0,
    100% 0,
    100% calc(100% - var(--triangle-height)),
    50% 100%,
    0 calc(100% - var(--triangle-height)),
    0 0,
    0 0
  );
  @supports (clip-path: shape(from 0 0, close)) {
    clip-path: shape(
      from var(--radius) 0,
      hline to calc(100% - var(--radius)),
      arc to 100% var(--radius) of var(--radius) cw,
      vline to calc(100% - var(--triangle-height)),
      line to 50% 100%,
      line to 0 calc(100% - var(--triangle-height)),
      vline to var(--radius),
      arc to var(--radius) 0 of var(--radius) cw,
      close
    );
  }
`;

const Border = styled.div`
  position: absolute;
  inset: 0;
  background: var(--bundle-border-gradient, var(--c-nd-150));
  pointer-events: none;
  clip-path: polygon(
    evenodd,
    calc(var(--border)) var(--border),
    calc(100% - var(--border)) var(--border),
    calc(100% - var(--border)) var(--border),
    calc(100% - var(--border))
      calc(100% - var(--triangle-height) - var(--border)),
    50% calc(100% - var(--border)),
    var(--border) calc(100% - var(--triangle-height) - var(--border)),
    var(--border) var(--border),
    calc(var(--border)) var(--border),
    0 0,
    100% 0,
    100% var(--radius),
    100% calc(100% - var(--triangle-height)),
    50% 100%,
    0 calc(100% - var(--triangle-height)),
    0 0,
    0 0
  );
  @supports (clip-path: shape(from 0 0, close)) {
    clip-path: shape(
      evenodd from var(--radius) var(--border),
      hline to calc(100% - var(--radius)),
      arc to calc(100% - var(--border)) var(--radius) of
        calc(var(--radius) - var(--border)) cw,
      vline to calc(100% - var(--triangle-height) - var(--border)),
      line to 50% calc(100% - var(--border)),
      line to var(--border) calc(100% - var(--triangle-height) - var(--border)),
      vline to var(--radius),
      arc to var(--radius) var(--border) of calc(var(--radius) - var(--border))
        cw,
      close,
      move to var(--radius) 0,
      hline to calc(100% - var(--radius)),
      arc to 100% var(--radius) of var(--radius) cw,
      vline to calc(100% - var(--triangle-height)),
      line to 50% 100%,
      line to 0 calc(100% - var(--triangle-height)),
      vline to var(--radius),
      arc to var(--radius) 0 of var(--radius) cw,
      close
    );
  }
`;

export const BottomArrow = ({
  children,
  borderGradient,
}: PropsWithChildren<{
  borderGradient?: string;
}>) => (
  <Root
    style={
      {
        '--bundle-border-gradient': borderGradient,
        '--triangle-height': '30px',
        '--radius': '16px',
        '--border': '1px',
      } as CSSProperties
    }
  >
    {children}
    <Border />
  </Root>
);
